import React from 'react'
import './testimonials.css'
import AVTR1 from '../../assets/meme1.png'
import AVTR2 from '../../assets/meme2.png'
import AVTR3 from '../../assets/meme3.png'
import AVTR4 from '../../assets/meme4.png'
import AVTR5 from '../../assets/meme5.png'
import AVTR6 from '../../assets/meme6.png'
import AVTR7 from '../../assets/meme7.png'
import AVTR8 from '../../assets/meme8.png'
import AVTR9 from '../../assets/meme9.png'
import AVTR10 from '../../assets/meme10.png'
import AVTR11 from '../../assets/meme11.png'
import AVTR12 from '../../assets/meme12.png'
import AVTR13 from '../../assets/meme13.jpg'
import AVTR14 from '../../assets/meme14.png'
import AVTR15 from '../../assets/meme15.png'
import AVTR16 from '../../assets/meme16.jpg'

// import Swiper core and required modules
import { Pagination, Navigation } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';


const data = [
  {
    image: AVTR1,
    link: "https://www.instagram.com/at_a_glance_official/"
  },
  {
    image: AVTR2,
  },
  {
    image: AVTR3,
  },
  {
    image: AVTR4,
  },
  {
    image: AVTR5,
  },
  {
    image: AVTR6,
  },
  {
    image: AVTR7,
  },
  {
    image: AVTR8,
  },
  {
    image: AVTR9,
  },
  {
    image: AVTR10,
  },
  {
    image: AVTR11,
  },
  {
    image: AVTR12,
  },
  {
    image: AVTR13,
  },
  {
    image: AVTR14,
  },
  {
    image: AVTR15,
  },
  {
    image: AVTR16,
  },
]


const Testimonials = () => {
  return (
    <section id='memes'>
      <h5>Who doesn't love</h5>
      <h2>Memes</h2>
      <Swiper className="container testimonials__container" // install Swiper modules
      modules={[Pagination,Navigation]}
      spaceBetween={40}
      slidesPerView={1}
      navigation
      pagination={{ clickable: true }} >
        {
          data.map(({image,link}) => {
            return (
              <SwiperSlide className="testimonial">
                <div className="">
                  <img src={image} alt="Avatar One" />
                  <br />
                  <a href="https://www.instagram.com/at_a_glance_official/" className='btn' target="_blank">Visit Instagram!</a>
                </div>
              </SwiperSlide>
            )
          })
        }
      </Swiper>
    </section>
  )
}

export default Testimonials